import { Component } from '@angular/core'

@Component({
  selector: 'app-logo-icon',
  templateUrl: '../../../assets/images/icons/logo-icon.svg',
  styleUrls: ['./logo-icon.component.scss'],
  standalone: true
})
export class LogoIconComponent {}
